import React from 'react';

import {ChangeRequestMetadataReviewFeedback} from 'src/modules/ai';
import {POSSIBLE_VALUES_FIELD_NAME} from 'src/modules/ai/constants';
import {
    ATTRIBUTE_DEPRECATED_INFO,
    ATTRIBUTE_DESCRIPTION_INFO,
    ATTRIBUTE_INFO, ATTRIBUTE_LAST_USAGE_DATE_INFO,
    DATA_TYPE_INFO,
    POSSIBLE_VALUES_INFO,
    REQUIRED_INFO,
} from 'src/modules/event-create/event-create-hovers';

import {Dropdown} from '@pb/kit-component-dropdown-v2';
import {EllipsisTextHint} from '@pb/kit-component-ellipsis-text-hint';
import {Group, Item} from '@pb/kit-component-group';
import {InfoIconButton} from '@pb/kit-component-icon-button';

import {EventCreationMode} from '../../constants';
import {ColumnWidth} from '../constants';

type Props = {
    mode: EventCreationMode,
    changeRequestId: number | null,
};

export const AttributeFormHeader = ({mode, changeRequestId}: Props) => {
    return (
        <Item style={{width: '100%'}}>
            <Group gap="s">
                <Item style={{width: ColumnWidth.attribute}}>
                    <Group gap="xs" alignItems="center">
                        <strong>Attribute</strong>
                        <Dropdown
                            hoverEnabled={true}
                            clickEnabled={false}
                            maxWidth={500}
                            anchor={({anchorRef, getAnchorProps}) => (
                                <InfoIconButton {...getAnchorProps()} ref={anchorRef}/>
                            )}>
                            {ATTRIBUTE_INFO}
                        </Dropdown>
                    </Group>
                </Item>
                <Item style={{width: ColumnWidth.description}}>
                    <Group gap="xs" alignItems="center">
                        <strong>Attribute Description</strong>
                        <Dropdown
                            hoverEnabled={true}
                            clickEnabled={false}
                            maxWidth={500}
                            anchor={({anchorRef, getAnchorProps}) => (
                                <InfoIconButton {...getAnchorProps()} ref={anchorRef}/>
                            )}>
                            {ATTRIBUTE_DESCRIPTION_INFO}
                        </Dropdown>
                    </Group>
                </Item>
                <Item style={{width: ColumnWidth.dataType}}>
                    <Group gap="xs" alignItems="center">
                        <strong>Data Type</strong>
                        <Dropdown
                            hoverEnabled={true}
                            clickEnabled={false}
                            maxWidth={500}
                            maxHeight={800}
                            anchor={({anchorRef, getAnchorProps}) => (
                                <InfoIconButton {...getAnchorProps()} ref={anchorRef}/>
                            )}>
                            {DATA_TYPE_INFO}
                        </Dropdown>
                    </Group>
                </Item>
                <Item style={{width: ColumnWidth.possibleValues}}>
                    <Group gap="xs" alignItems="center">
                        <strong>Possible Values</strong>
                        <Dropdown
                            hoverEnabled={true}
                            clickEnabled={false}
                            maxWidth={500}
                            anchor={({anchorRef, getAnchorProps}) => (
                                <InfoIconButton {...getAnchorProps()} ref={anchorRef}/>
                            )}>
                            {POSSIBLE_VALUES_INFO}
                        </Dropdown>
                        <ChangeRequestMetadataReviewFeedback
                            changeRequestId={changeRequestId}
                            fieldName={POSSIBLE_VALUES_FIELD_NAME}
                        />
                    </Group>
                </Item>
                {mode === EventCreationMode.update && (
                    <Item style={{width: ColumnWidth.lastUsageDate}}>
                        <Group gap="xs" alignItems="center">
                            <EllipsisTextHint>
                                <strong>Last Usage Date</strong>
                            </EllipsisTextHint>
                            <Dropdown
                                hoverEnabled={true}
                                clickEnabled={false}
                                maxWidth={500}
                                anchor={({anchorRef, getAnchorProps}) => (
                                    <InfoIconButton {...getAnchorProps()} ref={anchorRef}/>
                                )}>
                                {ATTRIBUTE_LAST_USAGE_DATE_INFO}
                            </Dropdown>
                        </Group>
                    </Item>
                )}
                <Item style={{width: ColumnWidth.required}}>
                    <Group gap="xs" alignItems="center">
                        <EllipsisTextHint>
                            <strong>Required</strong>
                        </EllipsisTextHint>
                        <Dropdown
                            hoverEnabled={true}
                            clickEnabled={false}
                            maxWidth={500}
                            anchor={({anchorRef, getAnchorProps}) => (
                                <InfoIconButton {...getAnchorProps()} ref={anchorRef}/>
                            )}>
                            {REQUIRED_INFO}
                        </Dropdown>
                    </Group>
                </Item>
                {mode === EventCreationMode.update && (
                    <Item style={{width: ColumnWidth.deprecated}}>
                        <Group gap="xs" alignItems="center">
                            <EllipsisTextHint>
                                <strong>Deprecated</strong>
                            </EllipsisTextHint>
                            <Dropdown
                                hoverEnabled={true}
                                clickEnabled={false}
                                maxWidth={500}
                                anchor={({anchorRef, getAnchorProps}) => (
                                    <InfoIconButton {...getAnchorProps()} ref={anchorRef}/>
                                )}>
                                {ATTRIBUTE_DEPRECATED_INFO}
                            </Dropdown>
                        </Group>
                    </Item>
                )}
                <Item style={{width: ColumnWidth.button}}>
                    <span/>
                </Item>
            </Group>
        </Item>
    );
};
